import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card } from "@mui/material";

const TIPS = {
  GM: "Read each highlighted sentence aloud, then rewrite it so it sounds right.",
  SP: "Pick the 3 spelling mistakes you find hardest and write each one out 3 times.",
  VC: "Choose one plain word in your essay and replace it with a more exact one.",
};

const SKILL_TAGS = { GM: "grammar", VC: "vocabulary", SP: "spelling" };
const PRACTICE_GRADES = ["P4", "P5"];

// The learner's own mistakes, handed to the game so it can turn them into practice questions.
function essayErrorsFrom(scores) {
  const out = [];
  (scores || []).forEach((s) => {
    const info = s.scoreInfo || {};
    if (s.c === "GM") {
      (info.errors || []).forEach((e) => e && e.w && e.r && out.push({ skill: "grammar", w: e.w, r: e.r }));
    }
    if (s.c === "SP") {
      [info.levelItems0, info.levelItems1, info.levelItems2].forEach((list) =>
        (list || []).forEach((e) => e && e.w && e.r && out.push({ skill: "spelling", w: e.w, r: e.r }))
      );
    }
  });
  return out.slice(0, 12);
}

export default function NextStepCard({ scores, suggestions, grade }) {
  const navigate = useNavigate();
  const ranked = (scores || []).filter((s) => typeof s.p === "number" && s.n);
  if (ranked.length === 0) return null;

  const weakest = ranked.reduce((a, b) => (b.p < a.p ? b : a));
  const tip = TIPS[weakest.c];
  const firstSuggestion = suggestions && suggestions.length > 0 ? suggestions[0] : null;

  const practisable = ranked.filter((s) => SKILL_TAGS[s.c]);
  const practiseScore = practisable.length > 0 ? practisable.reduce((a, b) => (b.p < a.p ? b : a)) : null;
  const canPractise = practiseScore && PRACTICE_GRADES.includes(grade);

  return (
    <Card
      id="next-step-card"
      variant="outlined"
      sx={{ padding: 2, marginBottom: 2, borderRadius: "24px", backgroundColor: "#FFF1BF", border: "3px solid #25204A", boxShadow: "0 6px 0 #25204A" }}
    >
      <Box display="flex" alignItems="center" sx={{ fontFamily: "'Playpen Sans', Inter, sans-serif", fontWeight: 800, fontSize: "1.4rem" }}>
        <span aria-hidden="true" style={{ marginRight: 8 }}>🎯</span>
        Your next step
      </Box>
      <Box sx={{ marginTop: 0.5 }}>
        Start with <b>{weakest.n}</b>. It is your lowest score, so a little work here helps the most.
      </Box>
      {(tip || firstSuggestion) && (
        <Box sx={{ marginTop: 0.5 }}>
          <b>Try this:</b> {tip || firstSuggestion}
        </Box>
      )}
      {canPractise && (
        <Button
          variant="contained"
          color="success"
          sx={{ marginTop: 1 }}
          onClick={() =>
            navigate(`/game?skill=${SKILL_TAGS[practiseScore.c]}&grade=${grade}`, { state: { errors: essayErrorsFrom(scores) } })
          }
        >
          Practise {practiseScore.n}
        </Button>
      )}
    </Card>
  );
}
